import { createModel } from 'xstate/lib/model';

import baseEvents from 'features/Bento/libs/machines/config/baseEvents';
import { AddressSchema } from 'features/Onboarding/components/AddressForm/addressSchema';
import { ApplicantType } from 'features/Onboarding/types';

import { PersonalAddressQuery } from '../graphql/queries/personalAddress.gql';

type PersonalAddressModuleData = {
  personalAddressData: PersonalAddressQuery;
  applicantType: ApplicantType;
};

export type Context = {
  getModuleData: () => PersonalAddressModuleData;
};

const context: Context = {
  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
};

const model = createModel(context, {
  events: {
    ...baseEvents,
    SUBMIT_ADDRESS: (data: AddressSchema) => ({ data }),
  },
});

export type Model = typeof model;

export default model;
